const video = document.getElementById("how-to-use-remove");
const fullscreenButton = document.querySelector(".full-screen");

fullscreenButton.addEventListener("click", function () {
  if (video.webkitSupportsFullscreen) {
    video.webkitEnterFullscreen();
    return;
  }

  video.requestFullscreen();
});

document.addEventListener("fullscreenchange", function () {
  if (document.fullscreenElement) {
    video.setAttribute("controls", true);
    return;
  }

  video.removeAttribute("controls");
});